import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {NgOptimizedImage} from '@angular/common'
import {ReplacePropsPipe} from '../../../../shared/pipes/replace-props.pipe'

interface CoverContent {
  title: string
  titleProps?: Record<string, string>
  subtitle: string
  subtitleProps?: Record<string, string>
  isSellingPointBarShown: boolean
}

@Component({
  selector: 'bgo-hero-cover-offering',
  templateUrl: './hero-cover-offering.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgOptimizedImage, ReplacePropsPipe],
})
export class HeroCoverOfferingComponent {
  @Input() content!: CoverContent
}
